<template>
  <div>
    <b-overlay :show="showOverlay" rounded="sm">
      <ValidationObserver ref="searchForm" slim>
        <b-form @submit.prevent="submit">
          <b-row>
            <b-col md="3">
              <ValidationProvider
                name="Transport"
                :rules="{ required: true }"
                v-slot="vContext"
              >
                <b-form-group
                  :label="$gettext('Transport')+ '*'"
                  label-class="chr-label"
                  label-for="transport"
                  class="mb-0"
                >
                  <b-form-select
                    id="transport"
                    :options="transportOptions"
                    v-model="selectedTransport"
                    size="sm"
                    :state="getValidationState(vContext)"
                    aria-describedby="transport"
                    >
                    <template v-slot:first>
                      <b-form-select-option :value="null" disabled v-translate>-- select --</b-form-select-option>
                    </template>
                  </b-form-select>
                  <b-form-invalid-feedback id="transport">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col md="3" v-if="selectedTransport !== 'own'">
              <ValidationProvider
                name="Departure"
                :rules="{ required: selectedTransport !== 'own' }"
                v-slot="vContext"
              >
                <b-form-group
                  :label="$gettext('Departure')+ '*'"
                  label-class="chr-label"
                  label-for="departure"
                  class="mb-0"

                >
                  <b-form-select
                    id="departure"
                    size="sm"
                    v-model="selectedDeparture"
                    :options="departureOptions"
                    :state="getValidationState(vContext)"
                    aria-describedby="departure"
                    >
                    <template v-slot:first>
                      <b-form-select-option :value="null" disabled v-translate>-- select --</b-form-select-option>
                    </template>
                    </b-form-select>
                    <b-form-invalid-feedback id="departure">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col md="3">
              <ValidationProvider
                name="Destination country"
                :rules="{ required: true }"
                v-slot="vContext"
              >
                <b-form-group
                  :label="$gettext('Destination country')+ '*'"
                  label-class="chr-label"
                  label-for="country"
                  class="mb-0"
                >
                  <b-form-select
                    id="country"
                    size="sm"
                    v-model="selectedCountry"
                    :options="countryOptions"
                    :disabled="!selectedDeparture && selectedTransport !== 'own'"
                    :state="getValidationState(vContext)"
                    aria-describedby="country"
                    >
                    <template v-slot:first>
                      <b-form-select-option :value="null" disabled v-translate>-- select --</b-form-select-option>
                    </template>
                  </b-form-select>
                  <b-form-invalid-feedback id="country">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col md="3">
              <ValidationProvider
                name="Resort"
                :rules="{ required: true }"
                v-slot="vContext"
              >
                <b-form-group
                  :label="$gettext('Resort')+ '*'"
                  label-class="chr-label"
                  label-for="resort"
                  class="mb-0"
                >
                  <b-form-select
                    id="resort"
                    size="sm"
                    v-model="selectedResort"
                    :options="resortOptions"
                    :disabled="!selectedCountry"
                    :state="getValidationState(vContext)"
                    aria-describedby="resort"
                    >
                    <template v-slot:first>
                      <b-form-select-option :value="null" disabled v-translate>-- select --</b-form-select-option>
                    </template>
                  </b-form-select>
                  <b-form-invalid-feedback id="resort">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
                <b-form-group
                  :label="$gettext('Area')"
                  label-class="chr-label"
                  label-for="area"
                  class="mb-0"
                >
                  <b-form-select
                    id="area"
                    size="sm"
                    v-model="selectedArea"
                    :options="areaOptions"
                    :disabled="!selectedResort"
                    >
                    <template v-slot:first>
                      <b-form-select-option :value="null" v-translate>-- any --</b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
            </b-col>
            <b-col md="2">
              <ValidationProvider
                name="Departure date"
                :rules="{ required: true }"
                v-slot="vContext"
              >
                <b-form-group
                  :label="$gettext('Departure date')+ '*'"
                  label-class="chr-label"
                  label-for="dDate"
                  class="mb-0"
                >
                  <b-form-select
                    id="dDate"
                    size="sm"
                    v-model="selectedDate"
                    :options="dateOptions"
                    :disabled="!selectedResort"
                    :state="getValidationState(vContext)"
                    aria-describedby="dDate"
                    >
                    <template v-slot:first>
                      <b-form-select-option :value="null" disabled v-translate>-- select --</b-form-select-option>
                    </template>
                  </b-form-select>
                  <b-form-invalid-feedback id="dDate">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col md="2">
              <ValidationProvider
                name="Nights "
                :rules="{ required: true }"
                v-slot="vContext"
              >
                <b-form-group
                  :label="$gettext('Nights')+ '*'"
                  label-class="chr-label"
                  label-for="duration"
                  class="mb-0"
                >
                  <b-form-select
                    id="duration"
                    size="sm"
                    v-model="selectedDuration"
                    :options="durationOptions"
                    :disabled="!selectedDate"
                    :state="getValidationState(vContext)"
                    aria-describedby="duration"
                    >
                    <template v-slot:first>
                      <b-form-select-option :value="null" disabled v-translate>-- select --</b-form-select-option>
                    </template>
                  </b-form-select>
                  <b-form-invalid-feedback id="duration">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col md="3">
                <b-form-group
                  :label="$gettext('Hotel')"
                  label-class="chr-label"
                  label-for="hotel"
                  class="mb-0"
                >
                  <b-form-select
                    id="hotel"
                    size="sm"
                    v-model="selectedHotel"
                    :options="hotelOptions"
                    :disabled="!selectedResort"
                    >
                    <template v-slot:first>
                      <b-form-select-option :value="null" v-translate>-- any --</b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
            </b-col>
            <b-col md="2">
                <b-form-group
                  :label="$gettext('Category')"
                  label-class="chr-label"
                  label-for="category"
                  class="mb-0"
                >
                  <b-form-select
                    id="category"
                    size="sm"
                    v-model="selectedCategory"
                    :options="categoryOptions"
                    >
                    <template v-slot:first>
                      <b-form-select-option :value="null" v-translate>-- any --</b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" v-for="(room, i) in selectedParams.rooms" :key="genRoomKey(i)">
              <b-form-group
                :label="$gettext('Room') + ' ' + (i + 1)"
                label-class="chr-label"
                class=""
              >
                <room
                  v-model="selectedParams.rooms[i]"
                  :id="i"
                  :showDelete="i && (selectedParams.rooms.length > 1)"
                  :showAdd = "!i && (selectedParams.rooms.length < 3)"
                  @add = "onRoomAdd"
                  @delete = "onRoomDelete(i)">
                </room>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12"><hr class="mt-0 mb-2"></b-col>
            <!-- <b-col sm="6">
              <b-button variant="primary" size="sm" type="submit" @click.prevent="$emit('openFees')">
                <b-icon icon="bookmarks-fill" /><span class="ml-2" v-translate>Mark up</span>
              </b-button>
            </b-col> -->
            <b-col sm="12" class="d-flex align-items-center justify-content-end">
              <b-button variant="warning" size="sm" type="submit"><b-icon icon="search" /><span class="ml-2" v-translate>Search</span></b-button>
            </b-col>
          </b-row>
        </b-form>
      </ValidationObserver>
    </b-overlay>
  </div>
</template>

<script>
import moment from 'moment'
import room from '@/app/private/shared/components/search_form_room'
import formMixin from '@/app/private/shared/mixins/search_forms'
import { currencies } from '@/shared/utils'
import { hotelRatings } from 'b2b-common/utils/hotel'
import { transports } from '../services/helper'
import { getTransportTypes, getDeparturePoints, getCountries, getResorts, getAreas, getHotels, getDates, getDurations } from 'b2b-common/services/api/package'
import validation from 'b2b-common/mixins/validation'
import toast from 'b2b-common/mixins/toast'

export default {
  name: 'PackageSearchForm',
  props: ['params'],
  mixins: [formMixin, validation, toast],
  components: { room },
  data () {
    return {
      selectedParams: {
        currency: null,
        packageType: null,
        transport: null,
        departure: null,
        country: null,
        resort: null,
        area: null,
        hotel: null,
        category: null,
        date: null,
        duration: null,
        rooms: [{}]
      },
      transportsList: [],
      departuresList: [],
      countriesList: [],
      resortsList: [],
      areasList: [],
      hotelsList: [],
      datesList: [],
      durationsList: []
    }
  },
  methods: {
    submit () {
      this.$refs.searchForm.validate().then(success => {
        if (!success) {
          this.addToast({
            title: this.$gettext('Invalid form'),
            message: this.$gettext('Please fill in all required fields!'),
            variant: 'danger'
          })
        } else {
          this.onSubmit()
        }
      })
    },
    async getTransportsList () {
      this.addRequest('transports')
      try {
        const res = await getTransportTypes({
          packageType: this.params.packageType,
          currency: this.selectedCurrency,
          dc: this.params.distribution
        })
        this.transportsList = res
        if (this.selectedTransport && !this.valueExistsInList('transports', this.selectedTransport)) {
          this.resetList(['departures', 'countries', 'resorts', 'areas', 'dates', 'durations', 'hotels'])
          this.selectedTransport = this.transports[0]
        }
      } finally { this.removeRequest('transports') }
      return this.transportsList
    },
    async getDeparturesList () {
      this.resetList('departures')
      this.addRequest('departures')
      try {
        let res = []
        if (this.selectedTransport !== 'own') {
          res = await getDeparturePoints({
            packageType: this.params.packageType,
            currency: this.selectedCurrency,
            transport: this.selectedTransport,
            dc: this.params.distribution
          })
        }
        this.departuresList = res
        if (this.selectedDeparture && !this.valueExistsInList('departures', this.selectedDeparture)) {
          this.resetList(['countries', 'resorts', 'areas', 'dates', 'durations', 'hotels'])
          this.selectedDeparture = null
        }
      } finally {
        this.removeRequest('departures')
      }
      return this.departuresList
    },
    async getCountriesList () {
      this.resetList('countries')
      this.addRequest('countries')
      try {
        let res = []
        if ((this.selectedTransport === 'own') || this.selectedDeparture) {
          res = await getCountries({
            packageType: this.params.packageType,
            currency: this.selectedCurrency,
            transport: this.selectedTransport,
            departure: this.selectedDeparture,
            dc: this.params.distribution
          })
        }
        this.countriesList = res
        if (this.selectedCountry && !this.valueExistsInList('countries', this.selectedCountry)) {
          this.resetList(['resorts', 'areas', 'dates', 'durations', 'hotels'])
          this.selectedCountry = null
        }
      } finally { this.removeRequest('countries') }
      return this.countriesList
    },
    async getResortsList () {
      this.resetList('resorts')
      this.addRequest('resorts')
      try {
        let res = []
        if (this.selectedCountry) {
          res = await getResorts({
            packageType: this.params.packageType,
            currency: this.selectedCurrency,
            transport: this.selectedTransport,
            departure: this.selectedDeparture,
            country: this.selectedCountry,
            dc: this.params.distribution
          })
        }
        this.resortsList = res
        if (this.selectedResort && !this.valueExistsInList('resorts', this.selectedResort)) {
          this.resetList(['areas', 'dates', 'durations', 'hotels'])
          this.selectedResort = null
        }
      } finally { this.removeRequest('resorts') }
      return this.resortsList
    },
    async getAreasList () {
      this.resetList('areas')
      this.addRequest('areas')
      try {
        let res = []
        if (this.selectedResort) {
          res = await getAreas({
            packageType: this.params.packageType,
            currency: this.selectedCurrency,
            transport: this.selectedTransport,
            departure: this.selectedDeparture,
            resort: this.selectedResort,
            dc: this.params.distribution
          })
        }
        this.areasList = res
        if (this.selectedArea && !this.valueExistsInList('areas', this.selectedArea)) {
          this.resetList(['dates', 'durations', 'hotels'])
          this.selectedArea = null
        }
      } finally { this.removeRequest('areas') }
      return this.areasList
    },
    async getHotelsList () {
      this.resetList('hotels')
      this.addRequest('hotels')
      try {
        let res = []
        if (this.selectedResort || this.selectedArea) {
          res = await getHotels({
            packageType: this.params.packageType,
            currency: this.selectedCurrency,
            transport: this.selectedTransport,
            departure: this.selectedDeparture,
            destination: this.selectedArea ? this.selectedArea : this.selectedResort,
            dc: this.params.distribution
          })
        }
        this.hotelsList = res
        if (this.selectedHotel && !this.valueExistsInList('hotels', this.selectedHotel)) {
          this.selectedHotel = null
        }
      } finally { this.removeRequest('hotels') }
      return this.hotelsList
    },
    async getDatesList () {
      this.resetList('dates')
      this.addRequest('dates')
      try {
        let res = []
        if (this.selectedResort || this.selectedArea) {
          res = await getDates({
            packageType: this.params.packageType,
            currency: this.selectedCurrency,
            transport: this.selectedTransport,
            departure: this.selectedDeparture,
            destination: this.selectedArea ? this.selectedArea : this.selectedResort,
            dc: this.params.distribution
          })
        }
        this.datesList = res.map(el => el.date)
        if (this.selectedDate && !this.valueExistsInList('dates', this.selectedDate)) {
          this.resetList('durations')
          this.selectedDate = null
        }
      } finally { this.removeRequest('dates') }
      return this.datesList
    },
    async getDurationsList () {
      this.resetList('durations')
      this.addRequest('durations')
      try {
        let res = []
        if (this.selectedDate) {
          res = await getDurations({
            packageType: this.params.packageType,
            currency: this.selectedCurrency,
            transport: this.selectedTransport,
            departure: this.selectedDeparture,
            destination: this.selectedArea ? this.selectedArea : this.selectedResort,
            date: this.selectedDate,
            dc: this.params.dc
          })
        }
        this.durationsList = res
        if (this.selectedDuration && !this.valueExistsInList('durations', this.selectedDuration)) {
          this.selectedDuration = null
        }
      } finally { this.removeRequest('durations') }
      return this.durationsList
    }
  },
  computed: {
    selectedCurrency: {
      get () { return this.selectedParams.currency },
      async set (val) {
        this.selectedParams.currency = val
        await this.getTransportsList()
        if (this.selectedTransport !== 'own') await this.getDeparturesList()
        await this.getCountriesList()
        await this.getDeparturesList()
        await this.getResortsList()
        await this.getAreasList()
        this.getHotelsList()
        await this.getDatesList()
        this.getDurationsList()
      }
    },
    currencyOptions () {
      return currencies.map(el => ({ value: el.code, text: el.code }))
    },
    selectedTransport: {
      get () { return this.selectedParams.transport },
      async set (val) {
        this.selectedParams.transport = val
        if (val !== 'own') await this.getDeparturesList()
        await this.getCountriesList()
        await this.getResortsList()
        await this.getAreasList()
        this.getHotelsList()
        await this.getDatesList()
        this.getDurationsList()
      }
    },
    transportOptions () {
      return this.transportsList.map(el => {
        const tr = transports.find(entry => entry.code === el)
        return { value: tr.code, text: tr.label }
      })
    },
    selectedDeparture: {
      get () {
        return this.selectedParams.departure
      },
      async set (val) {
        this.selectedParams.departure = val
        await this.getCountriesList()
        await this.getResortsList()
        await this.getAreasList()
        this.getHotelsList()
        await this.getDatesList()
        this.getDurationsList()
      }
    },
    departureOptions () {
      return this.departuresList.map(el => ({ value: el.id, text: el.name }))
    },
    selectedCountry: {
      get () {
        return this.selectedParams.country || null
      },
      async set (val) {
        this.selectedParams.country = val
        await this.getResortsList()
        await this.getAreasList()
        this.getHotelsList()
        await this.getDatesList()
        this.getDurationsList()
      }
    },
    countryOptions () {
      return this.countriesList.map(el => ({ value: el.id, text: el.name }))
    },
    selectedResort: {
      get () { return this.selectedParams.resort || null },
      async set (val) {
        this.selectedParams.resort = val
        await this.getAreasList()
        this.getHotelsList()
        await this.getDatesList()
        this.getDurationsList()
      }
    },
    resortOptions () {
      return this.resortsList.map(el => ({ value: el.id, text: el.name }))
    },
    selectedArea: {
      get () { return this.selectedParams.area },
      async set (val) {
        this.selectedParams.area = val
        this.getHotelsList()
        await this.getDatesList()
        this.getDurationsList()
      }
    },
    areaOptions () {
      return this.areasList.map(el => ({ value: el.id, text: el.name }))
    },
    selectedHotel: {
      get () { return (Array.isArray(this.selectedParams.hotels) && this.selectedParams.hotels.length) ? this.selectedParams.hotels[0] : null },
      set (val) { this.selectedParams.hotels = val ? [val] : null }
    },
    hotelOptions () {
      return this.hotelsList.map(el => ({ value: el.id, text: el.name }))
    },
    selectedCategory: {
      get () { return this.selectedParams.category },
      set (val) { this.selectedParams.category = val }
    },
    categoryOptions () {
      return hotelRatings.map(el => ({ value: el, text: el + ' ' + this.$gettext('stars') }))
    },
    selectedDate: {
      get () { return this.selectedParams.date },
      set (val) {
        this.selectedParams.date = val
        this.getDurationsList()
      }
    },
    dateOptions () {
      return this.datesList.map(el => ({ value: el, text: moment.unix(el).format('DD-MM-YYYY') }))
    },
    selectedDuration: {
      get () { return this.selectedParams.duration },
      set (val) { this.selectedParams.duration = val }
    },
    durationOptions () {
      return this.durationsList.map(el => ({ value: el, text: el }))
    },
    showOverlay () { return this.activeRequests.length > 0 }
  },
  created () {
    this.selectedParams = { ...this.params }
    this.getTransportsList()
    if (this.selectedTransport !== 'own') this.getDeparturesList()
    this.getCountriesList()
    this.getResortsList()
    this.getAreasList()
    this.getDatesList()
    this.getHotelsList()
    this.getDurationsList()
  }
}

</script>
<style lang="scss">

</style>
